import { DashboardModuleKey } from "../../Models/dashboard";

// Pages that belong to each module; opening any of them counts as a visit.
const MODULE_PATH_PREFIXES: Partial<Record<DashboardModuleKey, string[]>> = {
  virtual_team_members: ["/como-experts"],
  voices: ["/voices"],
  ambassador: ["/ambassador"],
  entities: ["/entity"],
  evaluation: ["/evaluation", "/evaluation_in_progress", "/evaluation_error"],
  question_lists: ["/questions_list", "/question_list"],
  knowledge_bases: ["/knowledge_base"],
  help_desk: ["/help-desk", "/help-desk-admin"],
  order_an_expert: ["/expert-form"],
  admin_dashboard: ["/admin-dashboard"],
};

export const moduleKeyForPath = (
  pathname: string,
): DashboardModuleKey | null => {
  const entries = Object.entries(MODULE_PATH_PREFIXES) as [
    DashboardModuleKey,
    string[],
  ][];
  const match = entries.find(([, prefixes]) =>
    prefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    ),
  );
  return match ? match[0] : null;
};
